import { useEffect, useState } from "react";
import { Card, Progress, Spin, Tag, Empty } from "antd";
import { TeamOutlined } from "@ant-design/icons";

import { getTeamTargetProgress } from "../../services/salesTargetService";

const TeamTargetCard = () => {

   const [loading, setLoading] = useState(true);
   const [team, setTeam] = useState([]);

   const fetchTeamProgress = async () => {

      try {

         setLoading(true);

         const data = await getTeamTargetProgress();

         setTeam(data.data);

      } catch (err) {

         console.error(err);

      } finally {

         setLoading(false);

      }

   };

   useEffect(() => {
      fetchTeamProgress();
   }, []);

   if (loading) {
      return (
         <Card>
            <Spin />
         </Card>
      );
   }
   if (!team.length) {
      return (
         <Card title="Team Sales Target">
            <Empty description="No active targets found." />
         </Card>
      );
   }

   return (
      <Card
         bordered={false}
         style={{
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,.05)"
         }}
         title={
            <div className="flex items-center justify-between">
               <div className="flex items-center gap-2">
                  <TeamOutlined />
                  <span className="font-semibold">
                     Team Sales Target
                  </span>
               </div>

               <div className="flex gap-2">

                  <Tag color="blue">
                     Team {team.length}
                  </Tag>

                  <Tag color="green">
                     Eligible {
                        team.filter(
                           x => x.commission_status === "Eligible"
                        ).length
                     }
                  </Tag>

                  <Tag color="orange">
                     Pending {
                        team.filter(
                           x => x.commission_status === "Pending"
                        ).length
                     }
                  </Tag>

               </div>
            </div>
         }
      >

         <div className="space-y-4 team-scroll"
            style={{
               maxHeight: 300,
               overflowY: "auto",
               paddingRight: 6
            }}
         >

            {team.map((item) => (

               <div
                  key={item.id}
                  style={{
                     border: "1px solid #f0f0f0",
                     borderRadius: 10,
                     padding: 16
                  }}
               >

                  {/* Header */}

                  <div className="flex justify-between items-start mb-3">

                     <div>

                        <div
                           style={{
                              fontWeight: 600,
                              fontSize: 16
                           }}
                        >
                           {item.sales_person}
                        </div>

                        <div
                           style={{
                              color: "#6b7280",
                              marginTop: 4
                           }}
                        >
                           ₹ {item.achieved_amount.toLocaleString("en-IN")}
                           {" / "}
                           ₹ {item.target_amount.toLocaleString("en-IN")}
                        </div>

                     </div>

                     <Tag
                        color={
                           item.commission_status === "Eligible"
                              ? "green"
                              : "orange"
                        }
                     >
                        {item.commission_status}
                     </Tag>

                  </div>

                  {/* Progress */}

                  <Progress
                     percent={item.achievement_percentage}
                     showInfo={false}
                     strokeColor={
                        item.achievement_percentage >= 100
                           ? "#22c55e"
                           : item.achievement_percentage >= 50
                              ? "#faad14"
                              : "#1677ff"
                     }
                     strokeWidth={10}
                  />

                  {/* Footer */}

                  <div
                     className="flex justify-between items-center mt-3"
                  >

                     <div
                        style={{
                           color: "#2563eb",
                           fontWeight: 500
                        }}
                     >
                        Balance ₹{" "}
                        {item.remaining_amount.toLocaleString("en-IN")}
                     </div>

                     <div
                        style={{
                           fontWeight: 600,
                           color:
                              item.achievement_percentage >= 100
                                 ? "#22c55e"
                                 : "#1677ff"
                        }}
                     >
                        {item.achievement_percentage}%
                     </div>

                  </div>

               </div>

            ))}

         </div>

      </Card>
   );

};

export default TeamTargetCard;